import type { ApiResponseBody } from "@/lib/api/api-type-helper";

export type ProductPermissionScopeCode = ApiResponseBody<
  "/v2/session",
  "get"
>["hasPermissionScopes"][number];

export const PRODUCT_PERMISSION_SCOPE_CODES = {
  // Marketplace
  MARKETPLACE: "marketplace",
  // HR Force
  PEOPLE: "people",
  ORGANIZATION: "organization",
  ORGANIZATION_PLAN: "organization-restructuring",
  PUBLIC_IDS: "public-ids",
  CERTIFICATION: "certification",
  LABOR_CORE: "labor-core",
  CONTRACTOR_CORE: "contractor-core",
  TIME_AND_ATTENDANCE: "time-and-attendance",
  // IT Force
  // TODO: AppsからSoftwareに移行した際にUIは移行済だが、パーミッションの移行が現状できていない状態
  APPS: "apps",
  // SOFTWARE: "software",
  ACCESSES: "accesses",
  DEVICES: "devices",
  ID_MANAGEMENT: "id-management",
  LICENSES: "licenses",
  NETWORKS: "networks",
  STARLINK: "starlink",
  IT_OPERATION_CORE: "it-operation-core",
  // GA Force
  PLACE: "place",
  EQUIPMENT: "equipment",
  GA_OPERATION_CORE: "ga-operation-core",
  FLEET: "fleet",
  // LI Force
  CONTRACT: "contract",
  BUSINESS_PARTNER: "business-partner",
  // Settings
  USER_ACCOUNTS: "user-accounts",
  PERMISSION_AND_ROLE: "permission-and-role",
  CONTRACTING_CORPORATION_PROFILE: "contracting-corporation-profile",

  /** External Notification */
  EXTERNAL_NOTIFICATION: "external-notification",
  // BOE
  OPERATION_EVENT: "operation-event",
} as const;

export const isProductPermissionScopeCode = (
  code: string,
): code is ProductPermissionScopeCode => {
  // NOTE: 型が追加された際もコンパイルで落ちないようにダウンキャストする
  const codes: string[] = Object.values(PRODUCT_PERMISSION_SCOPE_CODES);
  return Object.values(codes).includes(code as ProductPermissionScopeCode);
};

/**
 * 表示しないスコープのリスト
 * 画面が提供されておらず、画面に見えると誤解を招くため除外するスコープを定義
 */
export const HIDDEN_PRODUCT_PERMISSION_SCOPE_CODES: readonly ProductPermissionScopeCode[] =
  [PRODUCT_PERMISSION_SCOPE_CODES.EXTERNAL_NOTIFICATION] as const;

/**
 * スコープが表示対象かどうかを判定する
 * @param scopeCode スコープコード
 * @returns 表示対象の場合 true
 */
export const isVisibleProductPermissionScope = (scopeCode: string): boolean => {
  return !(HIDDEN_PRODUCT_PERMISSION_SCOPE_CODES as readonly string[]).includes(
    scopeCode,
  );
};
